import * as service from "../service";
import { store } from "../../store";

/**
 * Mark one notification as read.
 * Backend: POST /api/notification/markNotificationRead/markNotificationRead
 */
export const MarkNotificationReadAPI = async (id: string) => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "POST",
      "api/notification/markNotificationRead/markNotificationRead",
      { id, user_id: user?.id },
    );
    return resp;
  } catch (err) {
    console.error(`MarkNotificationReadAPI ${err}`);
  }
};

/**
 * Mark every notification of the current user as read.
 * Backend: POST /api/notification/markAllNotificationsRead/markAllNotificationsRead
 */
export const MarkAllNotificationsReadAPI = async () => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "POST",
      "api/notification/markAllNotificationsRead/markAllNotificationsRead",
      { user_id: user?.id },
    );
    return resp;
  } catch (err) {
    console.error(`MarkAllNotificationsReadAPI ${err}`);
  }
};
